if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', class ShopTheLook extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initNavigation();
      this.initHotspots();
    }

    initNavigation() {
      const slideshow = this.querySelector('.shop-the-look__products-slideshow slideshow-component');
    
      if (!slideshow) {
        setTimeout(() => this.initNavigation(), 100);
        return;
      }
    
      const prevButton = this.querySelector('.shop-the-look__nav-button--prev');
      const nextButton = this.querySelector('.shop-the-look__nav-button--next');
    
      const updateButtonStates = () => {
        const currentIndex = slideshow.current || 0;
        const slideCount = slideshow.slides?.length || 0;
        const slidesPerView = 3;
        if (prevButton) prevButton.disabled = currentIndex === 0;
        if (nextButton) nextButton.disabled = currentIndex >= slideCount - slidesPerView;
      };
      if (prevButton) {
        prevButton.addEventListener('click', e => {
          e.preventDefault();
          if (slideshow && slideshow.previous) slideshow.previous();
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', e => {
          e.preventDefault();
          if (slideshow && slideshow.next) slideshow.next();
        });
      }
    
      slideshow.addEventListener('slideshow:select', updateButtonStates);
      setTimeout(updateButtonStates, 300);
    }

    initHotspots() {
      const checkSlideshow = () => {
        const slideshow = this.querySelector('.shop-the-look__products-slideshow slideshow-component');
        if (!slideshow) {
          setTimeout(checkSlideshow, 100);
          return;
        }

        const hotspots = this.querySelectorAll('.shop-the-look__hotspot');
        const productIdSpans = this.querySelectorAll('.shop-the-look__product-id');

        hotspots.forEach((hotspot) => {
          hotspot.addEventListener('click', () => {
            const hotspotProductId = hotspot.dataset.hotspotProductId;
            productIdSpans.forEach((span, index) => {
              if (span.dataset.productId === hotspotProductId) {
                if (slideshow && slideshow.select) {
                  slideshow.select(index);
                }
              }
            });
          });
        });
      };
      checkSlideshow();
    }

  });
}